import './style.scss'
import React from 'react'
import { FiSearch, FiX } from 'react-icons/fi'

export interface SearchFieldProps
    extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
    value?: string
    placeholder?: string
    onChange?: (value: string) => void
    onClear?: () => void
    width?: string
    className?: string
}

export const SearchField: React.FC<SearchFieldProps> = ({
                                                            value = '',
                                                            placeholder = 'Search...',
                                                            onChange,
                                                            onClear,
                                                            width = '100%',
                                                            className = '',
                                                            ...rest
                                                        }) => {
    return (
        <div
            className={`search-field ${className}`}
            style={{ width }}
        >
            <span className="search-field__icon">
                <FiSearch />
            </span>

            <input
                {...rest}
                className="search-field__input"
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange?.(e.target.value)}
            />

            {value && (
                <button
                    type="button"
                    className="search-field__clear"
                    onClick={() => {
                        onChange?.('')
                        onClear?.()
                    }}
                >
                    <FiX />
                </button>
            )}
        </div>
    )
}

export default SearchField